"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _AuthContext = require("../context/AuthContext");
var _api = require("../utils/api");
var _PageContext = require("../context/PageContext");
var _ReviewedDocumentContext = require("../context/ReviewedDocumentContext");
var _document = require("../utils/document");
var _documentUploadGuard = require("../utils/document-upload-guard");
var _FullPageContainer = _interopRequireDefault(require("../components/layout/FullPageContainer"));
var _ReviewLoadingState = _interopRequireDefault(require("@common/components/review/ReviewLoadingState"));
var _button = require("@design/ui/button");
var _ContentContainer = _interopRequireDefault(require("../components/layout/ContentContainer"));
var _webApi = require("../utils/web-api");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _userPermissions = _interopRequireDefault(require("../constants/user-permissions"));
var _PlaybooksListContainer = _interopRequireDefault(require("../components/submit-document/PlaybooksListContainer"));
var _constants = require("../constants");
var _AnalyticsContext = require("../context/AnalyticsContext");
var _RecentRuns = _interopRequireDefault(require("../components/common/RecentRuns"));
var _filterHeader = require("@common/components/filter-header");
var _confirmationDialog = require("@common/components/confirmation-dialog/confirmation-dialog");
var _foldedTextSearch = require("@common/utils/foldedTextSearch");
var _jsxRuntime = require("react/jsx-runtime");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t5 in e) "default" !== _t5 && {}.hasOwnProperty.call(e, _t5) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t5)) && (i.get || i.set) ? o(f, _t5, i) : f[_t5] = e[_t5]); return f; })(e, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var SelectorWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 0px;\n    gap: 4px;\n    width: 100%;\n    height: auto;\n    margin-bottom: 8px;\n    flex: none;\n    order: 0;\n    align-self: stretch;\n    flex-grow: 0;\n"])));
var SelectorLabel = _styledComponents.default.h3(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    width: 100%;\n    height: 28px;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 20px;\n    line-height: 140%;\n    display: flex;\n    align-items: center;\n    text-align: justify;\n    color: #3D3D3D;\n    flex: none;\n    order: 0;\n    flex-grow: 1;\n    margin: 0;\n    padding: 0;\n"])));
var PlaybooksContainer = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 0px 0px 32px 0px;\n    gap: 8px;\n    width: 100%;\n    flex: 1;\n    min-height: 0;\n    align-self: stretch;\n    overflow-y: auto;\n    overflow-x: hidden;\n\n    /* Hide scrollbar for Chrome, Safari and Opera */\n    &::-webkit-scrollbar {\n        display: none;\n    }\n\n    /* Hide scrollbar for IE, Edge and Firefox */\n    -ms-overflow-style: none;  /* IE and Edge */\n    scrollbar-width: none;  /* Firefox */\n\n    @keyframes fadeIn {\n        from {\n            opacity: 0;\n            transform: translateY(-5px);\n        }\n        to {\n            opacity: 1;\n            transform: translateY(0);\n        }\n    }\n"])));
var LoadingMessage = _styledComponents.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-style: normal;\n  font-size: 14px;\n  color: #6B7280;\n  text-align: center;\n  padding: 24px;\n"])));
var PageWrapper = _styledComponents.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  background: #FFFFFF;\n  display: flex;\n  flex-direction: column;\n"])));
var ScrollableContent = _styledComponents.default.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 0px;\n  gap: 16px;\n  width: 100%;\n  height: calc(100% - 44px);\n  overflow-y: auto;\n  overflow-x: hidden;\n  box-sizing: border-box;\n  position: relative;\n\n  /* Hide scrollbar for Chrome, Safari and Opera */\n  &::-webkit-scrollbar {\n    display: none;\n  }\n\n  /* Hide scrollbar for IE, Edge and Firefox */\n  -ms-overflow-style: none;  /* IE and Edge */\n  scrollbar-width: none;  /* Firefox */\n"])));
function formatAuthorName(author) {
  return author.split(/\s+/).map(function (part) {
    return part ? part.charAt(0).toUpperCase() + part.slice(1).toLowerCase() : part;
  }).join(" ");
}
function formatRunDuration(createdAt) {
  if (!createdAt) return "recently";
  var normalized = /[Zz]|[+-]\d{2}:?\d{2}$/.test(createdAt) ? createdAt : createdAt + "Z";
  // TODO: remove once backend stops labeling local-server wall-clock as UTC.
  // The reviews table is `timestamp` (no TZ) but the API serializes the naive
  // wall-clock with a `Z` suffix, so we compensate by re-interpreting it as
  // local time.
  var parsed = new Date(normalized);
  var correctedMs = parsed.getTime() + parsed.getTimezoneOffset() * 60000;
  var elapsedMs = Math.max(0, Date.now() - correctedMs);
  var seconds = Math.floor(elapsedMs / 1000);
  if (seconds < 60) return seconds === 1 ? "1 second ago" : "".concat(seconds, " seconds ago");
  var minutes = Math.floor(seconds / 60);
  if (minutes < 60) return minutes === 1 ? "1 minute ago" : "".concat(minutes, " minutes ago");
  var hours = Math.floor(minutes / 60);
  return hours === 1 ? "1 hour ago" : "".concat(hours, " hours ago");
}
function InProgressReviewList(_ref) {
  var reviews = _ref.reviews;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex flex-col gap-3 min-h-[140px]",
    "data-sentry-component": "InProgressReviewList",
    "data-sentry-source-file": "SubmitDocumentPage.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "text-[#3D3D3D]",
      children: "Running multiple reviews at the same time can cause conflicts: each review analyzes the document state at the moment it started, so changes you apply from one review won't be reflected in the other."
    }), reviews.map(function (review) {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col gap-0.5 pl-3 border-l-2 border-primary",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "font-medium text-[#3D3D3D]",
          children: review.playbooks.map(function (p) {
            return p.name;
          }).filter(Boolean).join(", ") || "Unknown playbook"
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "text-xs text-[#686766]",
          children: ["Started ", formatRunDuration(review.createdAt), review.author ? " by ".concat(formatAuthorName(review.author)) : ""]
        })]
      }, review.id);
    })]
  });
}
function ResolvedReviewMessage() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "flex flex-col gap-3 min-h-[140px] justify-center",
    "data-sentry-component": "ResolvedReviewMessage",
    "data-sentry-source-file": "SubmitDocumentPage.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "text-[#3D3D3D]",
      children: "The previous review just finished. Starting your new run automatically \u2014 no conflict to worry about."
    })
  });
}
var SubmitDocumentPage = function SubmitDocumentPage() {
  var _usePage = (0, _PageContext.usePage)(),
    showPage = _usePage.showPage,
    currentPage = _usePage.currentPage;
  var _useState = (0, _react.useState)(""),
    _useState2 = _slicedToArray(_useState, 2),
    error = _useState2[0],
    setError = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isSubmitting = _useState4[0],
    setIsSubmitting = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    playbooks = _useState6[0],
    setPlaybooks = _useState6[1];
  var _useState7 = (0, _react.useState)([]),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedPlaybooks = _useState8[0],
    setSelectedPlaybooks = _useState8[1];
  // Real-time analysis is now always on
  var _useState9 = (0, _react.useState)(new Set()),
    _useState0 = _slicedToArray(_useState9, 2),
    expandedPlaybookIds = _useState0[0],
    setExpandedPlaybookIds = _useState0[1];
  var _useState1 = (0, _react.useState)(""),
    _useState10 = _slicedToArray(_useState1, 2),
    searchQuery = _useState10[0],
    setSearchQuery = _useState10[1];
  var _useState11 = (0, _react.useState)([]),
    _useState12 = _slicedToArray(_useState11, 2),
    statusFilter = _useState12[0],
    setStatusFilter = _useState12[1];
  var _useState13 = (0, _react.useState)([]),
    _useState14 = _slicedToArray(_useState13, 2),
    typeFilter = _useState14[0],
    setTypeFilter = _useState14[1];
  var _useState15 = (0, _react.useState)(null),
    _useState16 = _slicedToArray(_useState15, 2),
    pendingPlaybookIds = _useState16[0],
    setPendingPlaybookIds = _useState16[1];
  var authHeader = (0, _AuthContext.useAuthHeader)();
  var _useAuthInfo = (0, _AuthContext.useAuthInfo)(),
    userClass = _useAuthInfo.userClass,
    orgHelper = _useAuthInfo.orgHelper;
  var orgId = orgHelper === null || orgHelper === void 0 ? void 0 : orgHelper.getOrgIds()[0];
  var canRunPlaybooks = !!(orgId && userClass !== null && userClass !== void 0 && userClass.hasPermission(orgId, _userPermissions.default.RunPlaybook));
  var _useReviewedDocument = (0, _ReviewedDocumentContext.useReviewedDocument)(),
    applyActiveReview = _useReviewedDocument.applyActiveReview,
    reviewSummaries = _useReviewedDocument.reviewSummaries,
    currentReviewId = _useReviewedDocument.currentReviewId,
    isReportDone = _useReviewedDocument.isReportDone;
  var _useAnalytics = (0, _AnalyticsContext.useAnalytics)(),
    sendError = _useAnalytics.sendError;
  var inProgressReviews = reviewSummaries.filter(function (s) {
    return s.id === currentReviewId ? !isReportDone : !s.isReportDone;
  });
  var formatStatus = function formatStatus(status, isGlobalPlaybook) {
    if (isGlobalPlaybook) return "Global";
    if (!status) return "Unknown";
    return status.split("_").map(function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }).join(" ");
  };
  var filteredPlaybooks = (0, _react.useMemo)(function () {
    if (!playbooks) return [];
    return playbooks.filter(function (playbook) {
      if (!playbook || !playbook.name) return false;
      if (!(0, _foldedTextSearch.matchesSearch)(playbook.name, searchQuery)) {
        return false;
      }
      if (statusFilter.length > 0) {
        var playbookStatus = playbook.status || "unknown";
        if (!statusFilter.includes(playbookStatus)) {
          return false;
        }
      }
      if (typeFilter.length > 0) {
        var isGlobal = playbook.isGlobalPlaybook;
        var playbookType = isGlobal ? "global" : "custom";
        if (!typeFilter.includes(playbookType)) {
          return false;
        }
      }
      return true;
    });
  }, [JSON.stringify(playbooks), searchQuery, statusFilter, typeFilter]);
  var playbookFilterSections = [{
    title: "Type",
    options: [{
      label: "Global",
      value: "global"
    }, {
      label: "Custom",
      value: "custom"
    }],
    selectedValues: typeFilter,
    onSelectedValuesChange: setTypeFilter
  }, {
    title: "Status",
    options: [{
      label: "Active",
      value: "active"
    }, {
      label: "Draft",
      value: "draft"
    }, {
      label: "Initializing",
      value: "initializing"
    }],
    selectedValues: statusFilter,
    onSelectedValuesChange: setStatusFilter
  }];
  (0, _react.useEffect)(function () {
    var loadPlaybooks = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var playbooks;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (authHeader) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _context.n = 2;
              return (0, _webApi.fetchPlaybooks)(authHeader);
            case 2:
              playbooks = _context.v;
              if (Array.isArray(playbooks)) {
                setPlaybooks(playbooks);
              }
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function loadPlaybooks() {
        return _ref2.apply(this, arguments);
      };
    }();
    if (canRunPlaybooks && currentPage === _PageContext.PAGES.submitDocumentPage) {
      loadPlaybooks();
    }
  }, [currentPage]);
  var submitPlaybooks = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(playbookIds) {
      var force,
        uniquePlaybookIds,
        fileName,
        previousReviews,
        _yield$fetchDocName,
        base64String,
        primaryPlaybook,
        reviewTrackedChanges,
        reviewId,
        errorMessage,
        _args2 = arguments,
        _t,
        _t2,
        _t3,
        _t4;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            force = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : false;
            uniquePlaybookIds = Array.from(new Set(playbookIds.filter(Boolean)));
            if (!(uniquePlaybookIds.length === 0)) {
              _context2.n = 1;
              break;
            }
            setError("No playbooks selected");
            return _context2.a(2);
          case 1:
            if (authHeader) {
              _context2.n = 2;
              break;
            }
            return _context2.a(2);
          case 2:
            if (!(!force && inProgressReviews.length > 0)) {
              _context2.n = 3;
              break;
            }
            setPendingPlaybookIds(uniquePlaybookIds);
            return _context2.a(2);
          case 3:
            setIsSubmitting(true);
            fileName = "Unknown";
            previousReviews = [];
            _context2.p = 4;
            _context2.n = 5;
            return (0, _document.fetchDocName)();
          case 5:
            _t2 = _yield$fetchDocName = _context2.v;
            _t = _t2 !== null;
            if (!_t) {
              _context2.n = 6;
              break;
            }
            _t = _yield$fetchDocName !== void 0;
          case 6:
            if (!_t) {
              _context2.n = 7;
              break;
            }
            _t3 = _yield$fetchDocName;
            _context2.n = 8;
            break;
          case 7:
            _t3 = "New Document";
          case 8:
            fileName = _t3;
            _context2.n = 9;
            return (0, _documentUploadGuard.readDocumentForUpload)({
              component: "SubmitDocumentPage",
              action: "document_submission",
              sendError: sendError
            });
          case 9:
            base64String = _context2.v;
            if (!(base64String === null)) {
              _context2.n = 10;
              break;
            }
            return _context2.a(2);
          case 10:
            primaryPlaybook = playbooks === null || playbooks === void 0 ? void 0 : playbooks.find(function (playbook) {
              return uniquePlaybookIds.includes(playbook.id);
            });
            reviewTrackedChanges = (primaryPlaybook === null || primaryPlaybook === void 0 ? void 0 : primaryPlaybook.reviewTrackedChanges) || false; // previousReviews stays empty; run history is surfaced via RecentRuns instead.
            _context2.n = 11;
            return (0, _api.sendBase64ForReview)(authHeader, fileName, base64String, uniquePlaybookIds, reviewTrackedChanges, true,
            // runChecksOnly - always true now
            previousReviews);
          case 11:
            reviewId = _context2.v;
            _context2.n = 12;
            return (0, _document.appendPropertyToDocComments)("".concat(_constants.DIOPTRA_REVIEW_ID, "=").concat(reviewId));
          case 12:
            _context2.n = 13;
            return applyActiveReview(reviewId);
          case 13:
            showPage(_PageContext.PAGES.documentReviewPage);
            _context2.n = 15;
            break;
          case 14:
            _context2.p = 14;
            _t4 = _context2.v;
            console.error("Error processing document:", _t4);
            errorMessage = _t4 instanceof Error ? _t4.message : String(_t4);
            setError("Error processing document: " + errorMessage);
            sendError(_t4, {
              component: "SubmitDocumentPage",
              action: "document_submission",
              playbooks: uniquePlaybookIds,
              runChecksOnly: true,
              fileName: fileName,
              previousReviews: previousReviews
            });
          case 15:
            _context2.p = 15;
            setIsSubmitting(false);
            return _context2.f(15);
          case 16:
            return _context2.a(2);
        }
      }, _callee2, null, [[4, 14, 15, 16]]);
    }));
    return function submitPlaybooks(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var handleConfirmSubmit = function handleConfirmSubmit() {
    if (pendingPlaybookIds) void submitPlaybooks(pendingPlaybookIds, true);
    setPendingPlaybookIds(null);
  };
  (0, _react.useEffect)(function () {
    if (!pendingPlaybookIds || inProgressReviews.length > 0) return;
    var ids = pendingPlaybookIds;
    var handle = setTimeout(function () {
      void submitPlaybooks(ids, true);
      setPendingPlaybookIds(null);
    }, 1500);
    return function () {
      return clearTimeout(handle);
    };
  }, [pendingPlaybookIds, inProgressReviews.length]);
  var handleCancelSubmit = function handleCancelSubmit() {
    return setPendingPlaybookIds(null);
  };
  var handlePlaybookClick = function handlePlaybookClick(playbookId, event) {
    if ((event === null || event === void 0 ? void 0 : event.target) instanceof HTMLButtonElement) {
      return;
    }
    setSelectedPlaybooks(function (prev) {
      if (prev.includes(playbookId)) {
        return prev.filter(function (id) {
          return id !== playbookId;
        });
      }
      return [].concat(_toConsumableArray(prev), [playbookId]);
    });
    setExpandedPlaybookIds(function (prev) {
      var updated = new Set(prev);
      if (updated.has(playbookId)) {
        updated.delete(playbookId);
      } else {
        updated.add(playbookId);
      }
      return updated;
    });
  };
  var handleRunPlaybook = function handleRunPlaybook(playbookId) {
    setSelectedPlaybooks([playbookId]);
    void submitPlaybooks([playbookId]);
  };
  var handleViewPlaybook = function handleViewPlaybook(playbookId) {
    showPage(_PageContext.PAGES.playbookPage, {
      playbookId: playbookId,
      returnPage: _PageContext.PAGES.submitDocumentPage
    });
  };
  if (error) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(PageWrapper, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FullPageContainer.default, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          style: {
            marginBottom: "20px"
          },
          children: error
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
          variant: "outline",
          className: "w-full",
          onClick: function onClick() {
            setError("");
            setIsSubmitting(false);
          },
          children: "Try again"
        })]
      })
    });
  } else if (!canRunPlaybooks) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(PageWrapper, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FullPageContainer.default, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          style: {
            marginBottom: "20px",
            alignSelf: "center"
          },
          children: "User not allowed to run playbooks"
        })
      })
    });
  } else if (isSubmitting) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(PageWrapper, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FullPageContainer.default, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ReviewLoadingState.default, {})
      })
    });
  } else {
    return playbooks && /*#__PURE__*/(0, _jsxRuntime.jsxs)(PageWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_ContentContainer.default, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_filterHeader.FilterHeader, {
          searchQuery: searchQuery,
          onSearchQueryChange: setSearchQuery,
          searchPlaceholder: "Search playbooks\u2026",
          filterSections: playbookFilterSections
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(ScrollableContent, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              padding: "16px 16px 0",
              width: "100%",
              boxSizing: "border-box"
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_RecentRuns.default, {})
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_PlaybooksListContainer.default, {
            style: {
              padding: "0px 16px 16px",
              boxSizing: "border-box"
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(SelectorWrapper, {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(SelectorLabel, {
                children: "Playbooks"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(PlaybooksContainer, {
              children: [filteredPlaybooks.map(function (playbook) {
                var isExpanded = expandedPlaybookIds.has(playbook.id);
                var getStatusBadgeClasses = function getStatusBadgeClasses(status, isGlobal) {
                  var bgClass = 'bg-[#FEF2F2]';
                  var textClass = 'text-[#DC2626]';
                  if (isGlobal) {
                    bgClass = 'bg-[#FEF3C7]';
                    textClass = 'text-[#92400E]';
                  } else if (status === 'active') {
                    bgClass = 'bg-[#ECFDF3]';
                    textClass = 'text-[#027A48]';
                  } else if (status === 'draft') {
                    bgClass = 'bg-[#FEF3C7]';
                    textClass = 'text-[#92400E]';
                  }
                  return "".concat(bgClass, " ").concat(textClass);
                };
                return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  onClick: function onClick(e) {
                    return handlePlaybookClick(playbook.id, e);
                  },
                  className: "box-border flex flex-col gap-1 items-start p-2 w-full cursor-pointer transition-all duration-300 ".concat(isExpanded ? 'bg-background-primary-canvas border-b-2 border-[#D4D3D0]' : 'bg-white border-b border-[#D4D3D0] hover:bg-background-primary-canvas'),
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-row items-center justify-center gap-[10px] w-full",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                      className: "flex-1 min-w-0 font-normal text-base leading-[150%] tracking-[0.16px] text-[#171715] ".concat(isExpanded ? '' : 'overflow-hidden text-ellipsis whitespace-nowrap'),
                      children: playbook.name
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                      className: "inline-flex items-center justify-center px-2 py-0.5 rounded-[16px] text-xs tracking-[0.48px] leading-[1.2] whitespace-nowrap ".concat(getStatusBadgeClasses(playbook.status, playbook.isGlobalPlaybook)),
                      children: formatStatus(playbook.status, playbook.isGlobalPlaybook)
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    className: "w-full transition-all duration-300 ease-out",
                    style: {
                      display: 'grid',
                      gridTemplateRows: isExpanded ? '1fr' : '0fr'
                    },
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                      style: {
                        overflow: 'hidden'
                      },
                      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                        className: "flex flex-col items-start justify-center w-full",
                        children: [playbook.description && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                          title: playbook.description,
                          className: "w-full font-normal text-xs leading-[1.2] tracking-[0.48px] text-[#3D3D3D] overflow-hidden text-ellipsis",
                          style: {
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical'
                          },
                          children: playbook.description
                        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                          className: "flex flex-row items-center gap-[10px] w-full pb-[2px] pt-2",
                          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
                            onClick: function onClick(e) {
                              e.stopPropagation();
                              handleRunPlaybook(playbook.id);
                            },
                            className: "flex flex-row justify-center items-center px-3 py-2 gap-2 min-h-8 bg-primary border border-[#D4D3D0] rounded-[2px] cursor-pointer font-semibold text-sm leading-[1.2] tracking-[0.64px] text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--primary)]",
                            children: "Run"
                          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
                            onClick: function onClick(e) {
                              e.stopPropagation();
                              handleViewPlaybook(playbook.id);
                            },
                            className: "flex flex-row justify-center items-center px-3 py-2 gap-2 min-h-8 bg-[#F8F6F3] border border-[#D4D3D0] rounded-[2px] cursor-pointer font-semibold text-sm leading-[1.2] tracking-[0.64px] text-[#171715] focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--primary)]",
                            children: "View"
                          })]
                        })]
                      })
                    })
                  })]
                }, playbook.id);
              }), filteredPlaybooks.length === 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(LoadingMessage, {
                children: "No playbooks found"
              })]
            })]
          })]
        })]
      }), pendingPlaybookIds !== null && /*#__PURE__*/(0, _jsxRuntime.jsx)(_confirmationDialog.ConfirmationDialog, {
        tone: "primary",
        title: inProgressReviews.length === 0 ? "Previous review finished" : "Review already in progress",
        message: inProgressReviews.length === 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)(ResolvedReviewMessage, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(InProgressReviewList, {
          reviews: inProgressReviews
        }),
        confirmLabel: "Run anyway",
        cancelLabel: "Wait",
        onConfirm: handleConfirmSubmit,
        onCancel: handleCancelSubmit
      })]
    });
  }
};
var _default = exports.default = SubmitDocumentPage;